<template>
    <div id="onboarding-layout">
        <template>   
            <b-col class="mb-4" sm="12" align-v="center">
                <slot name="header"></slot>
            </b-col>

            <b-row class="vh-100" align-v="center">
                <b-col cols="12" md="8" offset-md="2" align-self="center" class="animated fadeIn">
                    
                    <transition 
                        name="slide"
                    >
                        <slot></slot>
                    </transition>
                </b-col>
            </b-row>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String
        },

        onboardingSuccess: {
            type: Boolean,
            default: false
        }
    },

    data: function() {
        return {}
    },

    computed: {
    },

    methods: {
        async pauseOnboarding() {      
            this.$emit("pauseOnboarding")
        },
    }
}
</script>

<style scoped>
#onboarding-layout {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    padding: 10px;
    background-color: #2c3135;
    overflow-x: scroll;
}
</style>